'use strict'
module.exports = {
  test: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  test_na: {
    host: 'https://test-passport.czur.cc',
    passportHost: 'https://test-passport.czur.cc/api/v1'
  },
  prod: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  },
  prod_na: {
    host: 'https://passport.czur.cc',
    passportHost: 'https://passport.czur.cc/api/v1'
  }
  // prod_na: {
  //   host: 'https://passport-na.czur.cc',
  //   passportHost: 'https://passport-na.czur.cc/api/v1'
  // }
}



// WEBPACK FOOTER //
// ./src/common/script/server.js